import React, { useState } from "react";
import { useI18n } from "@/i18n";
import { Button } from "@/components/ui/button";
import { Menu, X, Globe } from "lucide-react";

export default function Navbar() {
  const { lang, setLang, t } = useI18n();
  const [open, setOpen] = useState(false);

  const links = [
    { href: "#services", label: t.nav.services },
    { href: "#territory", label: t.nav.territory },
    { href: "#booking", label: t.nav.booking },
    { href: "#contact", label: t.nav.contact },
  ];

  return (
    <nav
      data-testid="main-navbar"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#F9F7F3]/80 border-b border-black/5"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="logo-link" className="flex items-center gap-3">
          <img
            src="/logo-mark.png"
            alt="Gallura Drive"
            className="w-11 h-11 object-contain"
            width="44"
            height="44"
          />
          <div className="leading-tight">
            <div className="font-display text-lg brand-text">Gallura Drive</div>
            <div className="text-xs text-slate-500 tracking-widest uppercase">
              Private Chauffeur
            </div>
          </div>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              className="text-sm text-slate-700 hover:brand-text transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <button
            data-testid="lang-toggle"
            onClick={() => setLang(lang === "it" ? "en" : "it")}
            className="hidden md:flex items-center gap-1 text-sm text-slate-700 hover:brand-text transition-colors"
          >
            <Globe className="w-4 h-4" />
            <span className="uppercase tracking-wider">{lang === "it" ? "EN" : "IT"}</span>
          </button>
          <Button
            data-testid="nav-book-now-btn"
            onClick={() => {
              document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
            }}
            className="hidden md:inline-flex brand-bg hover:opacity-90 text-white rounded-full px-5"
          >
            {t.nav.book_now}
          </Button>
          <button
            data-testid="mobile-menu-toggle"
            className="md:hidden p-2"
            onClick={() => setOpen(!open)}
          >
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-black/5 bg-[#F9F7F3] px-6 py-4 space-y-3">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-slate-700 py-2"
            >
              {l.label}
            </a>
          ))}
          <button
            data-testid="mobile-lang-toggle"
            onClick={() => setLang(lang === "it" ? "en" : "it")}
            className="flex items-center gap-2 text-slate-700 py-2"
          >
            <Globe className="w-4 h-4" /> {lang === "it" ? "English" : "Italiano"}
          </button>
          <Button
            data-testid="mobile-book-btn"
            onClick={() => {
              document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
              setOpen(false);
            }}
            className="w-full brand-bg text-white rounded-full"
          >
            {t.nav.book_now}
          </Button>
        </div>
      )}
    </nav>
  );
}
